import { Controller } from "@hotwired/stimulus"

// Removes its element — for a notice the reader can close (the builder's
// first-visit "Drafted with AI" callout, TASK-266.2). The server decides
// whether it shows again; this only takes it off the page.
export default class extends Controller {
  dismiss(event) {
    event.preventDefault()
    this.element.remove()
  }
}
